export default __webpack_public_path__ + "img/vlaanderen.11abfae3.svg";